import React from 'react'
import PageHeader from '../components/PageHeader'

const NIRF = () => {
    return (
        <div>
            <PageHeader title="NIRF" />
        </div>
    )
}

export default NIRF